import {
  ApplicationConfig,
  ErrorHandler,
  SecurityContext,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';
import { MARKED_OPTIONS, SANITIZE, provideMarkdown } from 'ngx-markdown';

import { appRoutes } from './app.routes';
import { cadixMarkedOptionsFactory } from './shared/cadix-chat/cadix-markdown-options';
import { ResizeObserverTolerantErrorHandler } from './resize-observer-error-handler';
import { authInterceptor } from './shared/auth/auth.interceptor';
import { CurrentUserService } from './shared/auth/current-user.service';
import { createOktaConfig } from './shared/auth/okta.config';
import { REVIEW_CLIENT_ROWS_PROJECT_IDS } from './shared/review/review.config';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Swallows only the benign "ResizeObserver loop" browser event (routinely
    // triggered by ag-grid layout passes), which would otherwise surface as a
    // fake runtime crash in the preview. All real errors pass through.
    { provide: ErrorHandler, useClass: ResizeObserverTolerantErrorHandler },
    provideZonelessChangeDetection(),
    provideOktaAuth(withOktaConfig(createOktaConfig())),
    CurrentUserService,
    {
      provide: REVIEW_CLIENT_ROWS_PROJECT_IDS,
      useValue: environment.reviewClientRowsProjectIds,
    },
    provideHttpClient(withInterceptors([authInterceptor])),
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: cadixMarkedOptionsFactory,
      },
      sanitize: {
        provide: SANITIZE,
        useValue: SecurityContext.HTML,
      },
    }),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
  ]
};
